import React from "react"
import orange from "./Orange.png"
import "./Logo.css"

function Logo() {
  return (
    <div className="Logo">
      <img src={orange} alt="Qarabao Logo" />
    </div>
  )
}

export default Logo
